import React from 'react';
import { TextField, TextFieldProps, InputAdornment } from '@mui/material';

interface BWITextFieldProps extends Omit<TextFieldProps, 'variant'> {
  startIcon?: React.ReactNode;
}

const BWITextField: React.FC<BWITextFieldProps> = ({ startIcon, ...props }) => {
  const { InputProps, ...restProps } = props;

  return (
    <TextField
      {...restProps}
      variant="outlined"
      InputProps={{
        ...InputProps,
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : InputProps?.startAdornment,
      }}
      fullWidth
    />
  );
};

export default BWITextField;
